import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class RoleService {
  static ENDPOINT = `${BASE}/role`;

  static async create(roleCreate) {
    return await request({
      url: `${this.ENDPOINT}/`,
      method: 'POST',
      body: roleCreate,
    })
  }

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      auth: false
    })
  }

  static async update(id, roleUpdate) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'PUT',
      body: roleUpdate
    })
  }

  static async delete(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'DELETE'
    })
  }
}

export default RoleService;
